import JSZip from 'jszip'

// 每个颜色一张代表图，按导出变种顺序排列，避免重复视角放大视觉请求。
export const selectAnalysisImages = (workbench, pi, mapping) => {
  const candidates = mapping.variants.length
    ? mapping.variants.map(v => v.main || v.sub.find(Boolean))
    : [workbench.products?.[pi]?.mainImage, mapping.single.find(i => i.url)?.url]
  const original = workbench.products?.[pi]?.mainImage
  const detail = workbench.products?.[pi]?.detailImages?.find(Boolean)
  const selected = candidates.filter(Boolean)
  // 不合并不同变种的代表图：即使图片地址相同，也必须保留颜色位置。
  for (const extra of [original, detail]) {
    if (extra && !selected.includes(extra)) selected.push(extra)
  }
  return selected
}

export const resizeAnalysisImage = async source => {
  // 远程地址由服务端现有白名单验证；不依赖浏览器跨域读取权限。
  if (!source.startsWith('data:image/') && !source.startsWith('blob:')) return source
  if (typeof Image === 'undefined') return source
  return new Promise((resolve, reject) => {
    const img = new Image()
    img.onload = () => {
      try {
        const scale = Math.min(1, 1024 / Math.max(img.naturalWidth, img.naturalHeight))
        const canvas = document.createElement('canvas')
        canvas.width = Math.max(1, Math.round(img.naturalWidth * scale))
        canvas.height = Math.max(1, Math.round(img.naturalHeight * scale))
        const ctx = canvas.getContext('2d')
        ctx.fillStyle = '#ffffff'
        ctx.fillRect(0, 0, canvas.width, canvas.height)
        ctx.drawImage(img, 0, 0, canvas.width, canvas.height)
        const resized = canvas.toDataURL('image/jpeg', 0.8)
        resolve(resized.length < source.length ? resized : source)
      } catch (error) { reject(new Error('分析图片处理失败，请重新选择图片')) }
    }
    img.onerror = () => reject(new Error('分析图片读取失败，请重新选择图片'))
    img.src = source
  })
}

// 服务端仍执行鉴权、计费和商品 JSON 打包；本地缓存图片直接补入 ZIP。
// 混合来源也适用：仅远程图片交给服务端下载，所有文件路径保持原样。
export const buildPackWithLocalImages = async (sku, productJson, images, requestPack) => {
  const local = []
  const remote = []
  for (const ref of images) {
    const match = /^data:image\/[^;,]+;base64,([\s\S]+)$/.exec(ref.url || '')
    if (match) local.push({ path: ref.path, base64: match[1] })
    else remote.push(ref)
  }
  if (!local.length) return requestPack(sku, productJson, remote)
  const serverZip = await requestPack(sku, productJson, remote)
  const zip = await JSZip.loadAsync(await serverZip.arrayBuffer())
  const productEntry = Object.keys(zip.files).find(p => /^[^/]+\/product\.json$/.test(p))
  if (!productEntry) throw new Error('商品包缺少 product.json，请重试')
  const folder = productEntry.slice(0, productEntry.lastIndexOf('/') + 1)
  for (const ref of local) {
    const entryPath = ref.path.replace(/\\/g, '/').replace(/^\/+/, '')
    if (entryPath.split('/').some(p => p === '..')) throw new Error('图片文件路径无效')
    zip.file(folder + entryPath, ref.base64, { base64: true, compression: 'STORE' })
  }
  // PNG/JPEG 已经压缩，重复 DEFLATE 对体积帮助小，却显著消耗 CPU。
  return zip.generateAsync({ type: 'blob', compression: 'STORE', streamFiles: true })
}
